/**
 * Ai 角色前后端字段适配：列表/详情统一 resourceName，保存仍用 wallpaperName。
 */
import {
  AI_ASSISTANT_ASSET_TYPE,
  AI_ASSISTANT_ROLE_LIST_MAX,
} from './aiAssistantConstants'

/** welcome / starters：归一化为非空字符串数组，最多 max 条。 */
export function normalizeAiRoleStringList(value, max = AI_ASSISTANT_ROLE_LIST_MAX) {
  const limit = Number.isFinite(max) && max > 0 ? max : AI_ASSISTANT_ROLE_LIST_MAX
  const items = []
  const pushText = (raw) => {
    const text = String(raw == null ? '' : raw).trim()
    if (!text) {
      return
    }
    if (items.length >= limit) {
      return
    }
    items.push(text)
  }
  if (Array.isArray(value)) {
    value.forEach(pushText)
  } else if (typeof value === 'string') {
    pushText(value)
  }
  return items
}

export function normalizeAiAssistantRow(row) {
  if (!row || typeof row !== 'object') {
    return row
  }
  const role = (row.jsonConfig && row.jsonConfig.aiRole) || {}
  return {
    ...row,
    resourceName: row.resourceName || row.wallpaperName || '',
    assetType: AI_ASSISTANT_ASSET_TYPE,
    roleName: row.roleName || role.name || '',
  }
}

export function normalizeAiAssistantList(rows) {
  return (rows || []).map(normalizeAiAssistantRow)
}

export const normalizeAiAssistantDetail = normalizeAiAssistantRow

/**
 * 编辑页加载后补齐 jsonConfig 结构，避免嵌套字段 undefined。
 */
/** 列表查询参数：与 AiAssistantController.list 字段对齐；空值不传，避免后端 Integer 解析 "undefined" */
export function toAiAssistantListQueryParams(state) {
  const params = {
    pageNum: state.currentPage,
    pageSize: state.currentPageSize,
  }
  if (state.resourceName) {
    params.wallpaperName = state.resourceName
  }
  if (state.roleNameFilter) {
    params.name2 = state.roleNameFilter
  }
  if (state.categoryId !== '' && state.categoryId != null) {
    params.categoryId = state.categoryId
  }
  if (state.wallpaperStatus !== '' && state.wallpaperStatus != null) {
    params.wallpaperStatus = state.wallpaperStatus
  }
  if (state.dataSetId !== '' && state.dataSetId != null) {
    params.dataSetId = state.dataSetId
  }
  return params
}

/** 批量打标 / 导出 Excel：resourceType=15，角色名走 name2 */
export function toAiAssistantExportQueryPayload(resourceType, filters, keySet) {
  const payload = {
    resourceType,
    wallpaperName: filters.resourceName || '',
    name2: filters.roleName || '',
  }
  if (filters.categoryType !== '' && filters.categoryType != null) {
    payload.categoryId = filters.categoryType
  }
  if (filters.dataSetId !== '' && filters.dataSetId != null) {
    payload.dataSetId = filters.dataSetId
  }
  if (
    filters.wallpaperStatus !== '' &&
    filters.wallpaperStatus != null &&
    filters.wallpaperStatus !== undefined
  ) {
    payload.wallpaperStatus = filters.wallpaperStatus
  }
  if (keySet && keySet.length) {
    payload.keySet = keySet
  }
  return payload
}

export function ensureAiAssistantJsonConfig(jsonConfig) {
  const base = jsonConfig && typeof jsonConfig === 'object' ? jsonConfig : {}
  const aiRole = base.aiRole && typeof base.aiRole === 'object' ? base.aiRole : {}
  const prompt = Array.isArray(base.prompt) && base.prompt.length
    ? base.prompt
    : [{ role: 'system', content: '' }]
  const normalizedAiRole = {
    name: aiRole.name || '',
    avatar: aiRole.avatar || '',
    welcome: normalizeAiRoleStringList(aiRole.welcome),
    starters: normalizeAiRoleStringList(aiRole.starters),
    introduction: aiRole.introduction || '',
    describe: aiRole.describe || '',
    bgL: aiRole.bgL || '',
    bgS: aiRole.bgS || '',
  }
  // exta 仍可能存在于存量 json_config（如 gender），运营端不再编辑，加载时原样保留
  if (aiRole.exta != null) {
    normalizedAiRole.exta = aiRole.exta
  }
  return {
    llmModel: base.llmModel || 'gpt-4.1-nano',
    prompt,
    aiRole: normalizedAiRole,
  }
}
